import { createFileRoute } from '@tanstack/react-router'

import OrdersPage from '@/features/services/pages/orders'

export const Route = createFileRoute('/_shell/orders')({ component: OrdersPage })
